import {jsonMember, jsonObject} from 'typedjson';
import {DataBase, TUPLA_TYPE} from './data-base';
import {PARAM_TYPE} from '../MessageContent/single-parameter';

@jsonObject
export class DataTuplaDescription extends DataBase {
  @jsonMember
  private name: string;
  @jsonMember
  private type: string;
  @jsonMember
  private chartDisabled: boolean;

  // Work attributes
  // tslint:disable-next-line:variable-name
  private _selected = false;

  // tslint:disable-next-line:variable-name
  private _visible = true;

  // Getter & Setter
  get selected(): boolean {
    return this._selected;
  }
  set selected(value: boolean) {
      this._selected = value;
  }

  get visible(): boolean {
    return this._visible;
  }

  set visible(value: boolean) {
    this._visible = value;
  }

  public switchSelected(): void {
    this.selected = !this.selected;
  }
  public get Type(): TUPLA_TYPE {
    return TUPLA_TYPE[this.type];
  }
  public get Name(): string {
    return this.name;
  }
  public set Name(value: string) {
    this.name = value;
  }
  public get ChartDisabled(): boolean {
    return this.chartDisabled;
  }
}
